import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import router from './router'
import VTooltip from 'v-tooltip'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

import './assets/styles/index.css';
import store from './store/index'

Vue.config.productionTip = false
// Vue.http.headers.common['Cache-Control'] = 'max-age=604800'


Vue.component('VueSlider', VueSlider);
Vue.use(VTooltip);
Vue.use(VueMeta)

new Vue({
  router,
  store: store,
  render: h => h(App),
}).$mount('#app')
